import { isAnyFanOn } from "src/pages/features/WeatherMonitorAntdOnly";

export const timestampHeader = "Timestamp" as const;
export const rangeFinderBushelsHeader = "Range Finder bu.";
export const rangeFinderPercentFullHeader = "Range FInder % Full";
export const userBushelsHeader = "User Bushels";
export const userPercentFullHeaer = "User % Full";
export const compressorPSIHeader = "Compressor PSI";
export const compressorStatusHeader = "Compressor Status";

const _generalTempF =  (name: string | null | undefined) => `${name} Temp F`;
const _generalRH =  (name: string | null | undefined) => `${name} RH`;
const _generalAH =  (name: string | null | undefined) => `${name} AH`;
const _generalDewPointF =  (name: string | null | undefined) => `${name} Dew Point F`;
const _generalMC =  (name: string | null | undefined) => `${name} MC %`;

export const chartCsvHeaders = {
    timestamp: timestampHeader,
    fanAmbientTempF: "Ambient Temp F" as const,
    fanAmbientRH: "Ambient RH" as const,
    fanAmbientAH: "Ambient AH" as const,
    fanAmbientDP: "Ambient Dew Point F" as const,
    fanAmbientEMC: "Ambient EMC %" as const,

    fanPlenumTempF: "Plenum Temp F" as const,
    fanPlenumRH: "Plenum RH" as const,
    fanPlenumAH: "Plenum AH" as const,
    fanPlenumDP: "Plenum Dew Point F" as const,
    fanPlenumEMC: "Plenum EMC %" as const,

    fanAmps: (fanId: string | null | undefined) => `${fanId} Amps`,
    fanHeaterAmps: (fanId: string | null | undefined) => `${fanId} Heater Amps`,
    fanPlenumPressureInH2O: (fanId: string | null | undefined) => `${fanId} Plenum Pressure inH2O`,
    fanIsOn: (fanId: string | null | undefined) => `${fanId} Status`,
    heaterStatus: (fanId: string | null | undefined) => `${fanId} Heater Status`,
    isAnyFanOn: () => `Any Fan On`,
    isAnyFanHeaterOn: () => `Any Heater On`,
    layerTempF: (sensor: string | null | undefined) => _generalTempF(sensor),
    layerRH: (sensor: string | null | undefined) => _generalRH(sensor),
    layerAh: (sensor: string | null | undefined) => _generalAH(sensor),
    layerDP: (sensor: string | null | undefined) => _generalDewPointF(sensor),
    layerMC: (sensor: string | null | undefined) => _generalMC(sensor),

    sensorTempF: (sensor: string | null | undefined) => _generalTempF(sensor),
    sensorRH: (sensor: string | null | undefined) => _generalRH(sensor),
    sensorAh: (sensor: string | null | undefined) => _generalAH(sensor),
    sensorDP: (sensor: string | null | undefined) => _generalDewPointF(sensor),
    sensorMC: (sensor: string | null | undefined) => _generalMC(sensor),
}